import { IError } from "dto/IError";
import { QueryFunction, useQuery, UseQueryOptions, UseQueryResult } from "react-query";

const useCustomQuery = <TData = any>(
    queryKey: string | any[],
    queryFn: QueryFunction<TData>,
    options?: UseQueryOptions<TData, IError>
  ): UseQueryResult<TData, IError> => {
    return useQuery<TData, IError>(queryKey, queryFn, options);
  };
  
  export default useCustomQuery;